export default __webpack_public_path__ + "static/media/secure.9b2b6f5c.svg";